import { useEffect } from "react";

import { useAppSelector } from "../useAppSelector";
import { useAppDispatch } from "../useAppDispatch";

import { setErrorMessage } from "../../store/slice/auth";

export const useLoginErrorMessage = (): { error: string | null } => {
  const error = useAppSelector((state) => state.auth.error);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let messageTimeout: NodeJS.Timeout;

    if (error) {
      messageTimeout = setTimeout(() => {
        dispatch(setErrorMessage(null));
      }, 2000);
    }

    return () => {
      if (messageTimeout) {
        clearTimeout(messageTimeout);
      }
    };
  }, [dispatch, error]);

  return { error };
};
